import React, {Component, memo} from "react";
import StroykaSlick from "./StroykaSlick";
import classNames from "classnames";
import languages from "../../i18n";
import {ZoomIn24Svg} from "../../svg";
import {isDefaultImage} from "../../services/utils";
import cls from "./shared.module.scss"
import {domainUrl} from "../../helper";
import Image from "next/image";
import {slickSettingsFeatured, slickSettingsThumbnails} from "../../services/breakpoints";

class ProductGallery extends Component {
    //@ts-ignore
    gallery;
    /** @var {Promise} */
    createGallery = null;
    imagesRefs = [];
    unmounted = false;

    //@ts-ignore
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            transition: false
        };
    }

    componentDidMount() {
        //@ts-ignore
        this.createGallery = import("../../photoswipe").then((module) => module.createGallery);

        setTimeout(() => {
            this.setState(() => ({
                transition: false
            }));
        }, 0);
    }

    //@ts-ignore
    componentDidUpdate(prevProps) {
        const {locale: prevLocale} = prevProps;
        //@ts-ignore
        const {direction: prevDirection} = languages[prevLocale];
        //@ts-ignore
        const {locale: currLocale} = this.props;
        //@ts-ignore
        const {direction: currDirection} = languages[currLocale];

        if (currDirection !== prevDirection) {

            setTimeout(() => {
                this.setState(() => ({
                    transition: false
                }));
            }, 0);
        }
    }

    componentWillUnmount() {
        if (this.gallery) {
            this.gallery.destroy();
        }

        this.unmounted = true;
    }

    //@ts-ignore
    getIndexDependOnDir(index) {
        //@ts-ignore
        const {images, locale} = this.props;
        //@ts-ignore
        const {direction} = languages[locale];

        // we need to invert index id direction === 'rtl' due to react-slick bug
        if (direction === "rtl") {
            return images.length - 1 - index;
        }

        return index;
    }

    //@ts-ignore
    handleFeaturedClick = (event, index) => {
        event.preventDefault();
        //@ts-ignore
        const {layout} = this.props;

        if (!this.createGallery || layout === "quickview") {
            return;
        }

        this.openPhotoswipe(index);
    };

    //@ts-ignore
    handleThumbnailClick = (index) => {
        //@ts-ignore
        const {transition} = this.state;

        if (transition) {
            return;
        }

        this.setState(() => ({currentIndex: index}));

        //@ts-ignore
        if (this.slickFeaturedRef) {
            //@ts-ignore
            this.slickFeaturedRef.slickGoTo(this.getIndexDependOnDir(index));
        }
    };

    //@ts-ignore
    handleFeaturedBeforeChange = (oldIndex, newIndex) => {
        this.setState(() => ({
            currentIndex: this.getIndexDependOnDir(newIndex),
            transition: true
        }));
    };

    //@ts-ignore
    handleFeaturedAfterChange = (index) => {
        this.setState(() => ({
            currentIndex: this.getIndexDependOnDir(index),
            transition: false
        }));
    };

    handleZoomButtonClick = () => {
        //@ts-ignore
        const {currentIndex} = this.state;
        this.openPhotoswipe(currentIndex);
    };

    //@ts-ignore
    setSlickFeaturedRef = (ref) => {
        //@ts-ignore
        this.slickFeaturedRef = ref;
    };

    //@ts-ignore
    openPhotoswipe(index) {
        //@ts-ignore
        const {images, locale} = this.props;

        //@ts-ignore
        const {direction} = languages[locale];

        const items = this.imagesRefs.map((tag, index) => {
            //@ts-ignore
            const width = parseFloat(tag.dataset.width) || tag.naturalWidth + 150;
            //@ts-ignore
            const height = parseFloat(tag.dataset.height) || tag.naturalHeight + 150;

            const storeDomain = process.env.storeDomain;
            let image = images[index].large_image_url;

            return {
                src: image,
                msrc: image,
                w: width,
                h: height
            };
        });

        if (direction === "rtl") {
            items.reverse();
        }

        const options = {
            //@ts-ignore
            getThumbBoundsFn: (index) => {
                const dirDependentIndex = this.getIndexDependOnDir(index);

                if (!this.imagesRefs[dirDependentIndex]) {
                    return null;
                }

                const tag = this.imagesRefs[dirDependentIndex];
                //@ts-ignore
                const width = tag.naturalWidth;
                //@ts-ignore
                const height = tag.naturalHeight;
                //@ts-ignore
                const rect = tag.getBoundingClientRect();
                const ration = Math.min(rect.width / width, rect.height / height);
                const fitWidth = width * ration;
                const fitHeight = height * ration;

                return {
                    x: rect.left + (rect.width - fitWidth) / 2 + window.pageXOffset,
                    y: rect.top + (rect.height - fitHeight) / 2 + window.pageYOffset,
                    w: fitWidth
                };
            },
            index: this.getIndexDependOnDir(index),
            bgOpacity: 0.9,
            history: false
        };

        //@ts-ignore
        this.createGallery.then((createGallery) => {
            /*FIXME commented for showing zoom effect in products inner page images// open after fixing this issue*/
            // if (this.unmounted) {
            //     return;
            // }


            this.gallery = createGallery(items, options);

            this.gallery.listen("beforeChange", () => {
                //@ts-ignore
                if (this.gallery && this.slickFeaturedRef) {
                    //@ts-ignore
                    this.slickFeaturedRef.slickGoTo(this.gallery.getCurrentIndex(), true);
                }
            });

            this.gallery.listen("destroy", () => {
                this.gallery = null;
            });

            this.gallery.init();
        });
    }

    render() {
        const dbName = process.env.domainName
        //@ts-ignore
        const {layout, images} = this.props;
        //@ts-ignore
        const {currentIndex} = this.state;

        //@ts-ignore
        const featured = images.map((image, index) => {
            const realImagePath = isDefaultImage(image.path) ? image.path : image.original_image_url
            return (
                <div
                    key={index}
                    className={`${cls["product-image"]} ${cls["product-image--location--gallery"]}`}
                >
                    <a
                        target="_blank"
                        rel="noreferrer"
                        className={cls["product-image__body"]}
                        href={realImagePath}
                        onClick={(event) => this.handleFeaturedClick(event, index)}
                    >
                        <img
                            alt="product-image"
                            className={cls["product-image__img"]}
                            src={realImagePath}
                            ref={(element) => {
                                //@ts-ignore
                                this.imagesRefs[index] = element;
                            }}
                        />
                    </a>
                </div>
            );
        });

        //@ts-ignore
        const thumbnails = images.map((image, index) => {

            const realImagePath = isDefaultImage(image.path) ? domainUrl(`${dbName}${image.path}`) : domainUrl(`${dbName}/storage/${image.path}`)

            const classes = classNames(
                `${cls["product-gallery__carousel-item"]} ${cls["product-image"]}`,
                {
                    [cls["product-gallery__carousel-item--active"]]: index === currentIndex
                }
            );

            return (
                <button
                    type="button"
                    key={index}
                    onClick={() => this.handleThumbnailClick(index)}
                    className={classes}
                >
                    <div className={cls["small-img-car_fms"]}>
                        <Image
                            src={realImagePath}
                            alt={"thumbnail product"}
                            placeholder="blur"
                            layout="fill"
                            priority
                            blurDataURL={`/zega/blur1.webp`}
                        />
                    </div>
                </button>
            );
        });

        return (
            <div className={cls["product__gallery"]}>
                <div className={cls["product-gallery"]}>
                    <div className={cls["product-gallery__featured"]}>
                        {layout !== "quickview" && (
                            <button
                                type="button"
                                className={cls["product-gallery__zoom"]}
                                onClick={this.handleZoomButtonClick}
                            >
                                <ZoomIn24Svg/>
                            </button>
                        )}
                        {
                            //@ts-ignore
                            <StroykaSlick
                                ref={this.setSlickFeaturedRef}
                                {...slickSettingsFeatured}
                                beforeChange={this.handleFeaturedBeforeChange}
                                afterChange={this.handleFeaturedAfterChange}
                            >
                                {featured}
                            </StroykaSlick>
                        }
                    </div>
                    {
                        //@ts-ignore
                        !this.props.ups
                        && (
                            <div className={`${cls["product-gallery__carousel"]} carousel-parent`}>
                                <StroykaSlick
                                    //@ts-ignore
                                    {...slickSettingsThumbnails[layout]}
                                >
                                    {thumbnails}
                                </StroykaSlick>
                            </div>
                        )
                    }

                </div>
            </div>
        );
    }
}

export default memo(ProductGallery)
